export const RECENT_COLOR_KEY = 'recent_color';
export const NO_COLOR = 'no_color';

export const RECENT_THEME_KEY = 'recent_theme';
